import { Component, ViewChild, TemplateRef, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { EditorComponent } from 'src/app/editor/editor.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SearchUsersComponent } from '../../search-users/search-users.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';

@Component({
  selector: 'app-parallel-workflow-actions',
  templateUrl: './parallel-workflow-actions.component.html',
  styleUrls: ['./parallel-workflow-actions.component.scss']
})
export class ParallelWorkflowActionsComponent implements OnInit, OnDestroy {
  isProcessing = false;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  oneQmsUsersDataForTable1: any = [];
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  oneQmsUsersDataForTable1Temp: any;
  dataTypeList: any = [];
  array: any = [];
  oneQmsOrgUsersDetails: any;
  searchText: any;

  codelistGroupList: any = [];
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  oneQmsUsersDataForFilter !: any[];
  dropDownDataForModule: any = [];
  makeStickyColumns: any;
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  searchByReviewByUser: any;
  ReviewByUserDropdown: any = [];
  visibleactionperfrom: boolean;
  listOfUsers: any;

  moduleNameForDropdown: any = [];
  documentTypeListDropdown: any = [];
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  }
  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, public qmsservice: qmsService, private readonly elem: ElementRef) {
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

  }

  dropDownActionType: any[] = [];

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.dropDownForRequestedAt = JSON.parse(sessionStorage.getItem('dropDownForRequestedAt') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.appService.getOneQmsUsersWithRolesVwDetails("QMS").subscribe((response: any) => {
      for (const element of response) {
        element.isActive = element.isActive == "Y";
      }
      this.listOfUsers = response;
      this.listOfUsers = this.listOfUsers.sort((a: any, b: any) => a.userName.localeCompare(b.userName));
      this.selectBoxeForUserList();
      this.isProcessing = false;
    });
    this.appService.getQmsBusinessAreasByModule(this.qmsservice.moduleName).subscribe((data: any) => {

      this.getQmsBusinessAreaDetail = data;
      this.filteredRequestedAtValue = this.getQmsBusinessAreaDetail;
      this.selectBoxeForRequestedAt();

    });
    if (this.qmsservice.moduleName === 'CAPA') {
      this.appService
        .getCodeListsByGroup("ACTION_TYPE")
        .subscribe((resp: any) => {
          this.dropDownActionType = resp.map((x: any) => ({
            valueExp: x.codelistCode,
            displayExp: x.codelistName
          }));
        });
    }

    this.appService.getCodeListsByGroup("DOCUMENT_TYPE").subscribe((data: any) => {
      this.dropDownDataForDocumentType = data;
      this.callSelectBoxValues();
      this.isProcessing = false;
    });
    this.getcallMethod();
  };




  dropDownDataForDocumentType: any;
  getcallMethod() {
    this.isProcessing = true;
    this.oneQmsUsersDataForTable1 = [];
    const data = {

      gridName: "PARALLEL_WORKFLOW_ACTIONS"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "PARALLEL_WORKFLOW_ACTIONS",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          codelistGroup: null,
          manualEntryDataFields: response.manualEntryDataFields,
          workflowId: this.qmsservice.workflowId,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.oneQmsUsersDataForTable1 = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const element of this.oneQmsUsersDataForTable1) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType == 'CHECKBOX') {
                    element[dataType.columnName] = element[dataType.columnName] == "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.oneQmsUsersDataForTable1;
            this.collectionSize = this.oneQmsUsersDataForTable1.length;
            this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1.length / this.itemsPerPage);
            this.dynamicLabelCall();
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.visibleDataGrid = true;
  }



  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.oneQmsUsersDataForTable1.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1.length, page, this.perPage, targetpage);
    this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.oneQmsUsersDataForTable1.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.oneQmsUsersDataForTable1) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.oneQmsUsersDataForTable1) {
        element.childCheckBoxs = false;
      }
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.oneQmsUsersDataForTable1[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;

    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.oneQmsUsersDataForTable1.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  }

  /* End Multi Row Select */
  visibleAuditTrail: any;
  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;
  searchManagerDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = true;
      }
    } else {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = false;
      }
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  };

  onClick(event: any) {
  }

  onlinkClick(event: any) {
    console.log();
  }

  addworkflow: any;
  requestedAtTxt: any;
  refreshGridData() {
    this.getcallMethod();
  };
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  popupTitle: any;
  parallelWorkflowActionObj: any = {};

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  };

  callSelectBoxValues() {
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
    this.selectBoxeForRequestedAt();
  }

  selectBoxeForDesignationCode() {
    for (const element of this.dropDownForDesignationCode) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }
  selectBoxeForUserList() {
    this.listOfUsersDropdown = [];
    for (const element of this.listOfUsers) {
      this.listOfUsersDropdown = this.listOfUsersDropdown.concat({
        valueExp: element.userId,
        displayExp: element.userName
      });
    }
  };

  selectBoxeForDepartmentCode() {
    this.departmentCodeDropdown = [];
    for (const element of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectBoxeForRequestedAt() {
    console.log(this.filteredRequestedAtValue);
    this.RequestedAtDropdown = [];
    for (const element of this.filteredRequestedAtValue) {
      this.RequestedAtDropdown = this.RequestedAtDropdown.concat({
        valueExp: element.taskRequestedAt,
        displayExp: element.taskRequestedAt
      });
    }
  }

  openAddPopup() {
    this.parallelWorkflowActionObj = {};
    this.addworkflow = true;
    this.searchingByRequestedAt = null;
    this.coreBusinessAreaNameValue = [];
    this.coreBusinessAreaNameDropdown = [];
    this.searchByDepartmentCode = null;
    this.visibleEditButton = false;
    this.popupTitle = "Create Action";
    this.bussinessAreaName = '';
    this.qmsservice.getQmsActionDataUsingById = {};
    this.parallelWorkflowActionObj.actionDescription = null;
    this.coreBusinessAreaNameSelected = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  };

  searchingByRequestedAt: any = [];
  coreBusinessAreaNameValue: any = [];
  visibleEditButton: boolean;
  actionNameFieldValue: any;
  activityAtFieldValue: any;
  coreBusinessAreaNameValueFieldValue: any;
  descriptionFieldValue: any;
  assignedToFieldValue: any;
  targetDateToFieldValue: any;
  performedActionDetailsFieldValue: any;
  getQmsBusinessAreaDetail: any;
  filteredRequestedAtValue: any;
  filteredBusinessAreaValue: any;
  coreBusinessAreaNameDropdown: any = [];
  selectCoreBusinessAreaNameValueExp: any = [];
  bussinessAreaName: any;
  dropDownForRequestedAt: any;
  isAdenabled: boolean = false;
  coreBusinessAreaNameTxt: any;
  assignedUserTxt: any;
  departmentCodeTxt: any;
  RequestedAtDropdown: any = [];
  listOfUsersDropdown: any;
  searchByDepartmentCode: any = null;
  selectedDepartmentValue: any;
  selectedDesignationValue: any;
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];

  openEditPopup(data: any, id: any) {
    this.coreBusinessAreaNameSelected = false;
    if (id == 0 || id == 1) {

      this.isProcessing = true;
      this.parallelWorkflowActionObj = {};

      this.appService.getParallelWorkflowActions(this.qmsservice.workflowId, data.ACTION_ID).subscribe((data: any) => {

        const item = data[0];
        this.parallelWorkflowActionObj = { ...item };
        data.actionPerformed = data.actionPerformed == "Y";

        if (this.qmsservice.moduleName === 'CAPA') {
          const rawValue = item.ACTION_TYPE || item.actionType || '';
          this.parallelWorkflowActionObj.actionType = rawValue ? rawValue.split(',') : [];
        } else {
          this.parallelWorkflowActionObj.actionType = null;
        }


        if (this.parallelWorkflowActionObj.targetDate) {
          this.parallelWorkflowActionObj.targetDate = new Date(this.parallelWorkflowActionObj.targetDate);
        } else {
          this.parallelWorkflowActionObj.targetDate = null;
        }


        this.popupTitle = "Update Action";

        if (data[0].actionAt != '' && data[0].actionAt != undefined && data[0].actionAt != null) {
          let businessAreaValues = this.filteredRequestedAtValue.filter((x: any) => x.taskRequestedAt === data[0].actionAt);
          if (businessAreaValues.length > 0) {
            this.filteredBusinessAreaValue = businessAreaValues[0].listOfBusinessArea?.split(',');
            this.searchingByRequestedAt = data[0].actionAt;
            this.onRequestedAtSelect(this.event, data[0].actionAt);
            this.coreBusinessAreaNameValue = [];
            if (data[0].coreBusinessArea) {
              if (this.coreBusinessAreaNameDropdown.length > 0) {
                this.coreBusinessAreaNameValue = data[0].coreBusinessArea?.split(",");
              } else {
                this.coreBusinessAreaNameValue = data[0].coreBusinessArea;
              }

            };
          } else {
            this.searchingByRequestedAt = data[0].actionAt;
          }
        }

        if (data[0].assignedToDepartment != '' && data[0].assignedToDepartment != undefined && data[0].assignedToDepartment != null) {
          let departmentCodeValues = this.dropDownForDepartmentCode.filter((x: any) => x.codelistCode === data[0].assignedToDepartment);
          if (departmentCodeValues.length > 0) {
            this.searchByDepartmentCode = departmentCodeValues[0].codelistCode;
          }
        }

        this.visibleEditButton = true;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        this.isProcessing = false;
      });
    }
  };

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  config: EditorConfig = {
    //placeholder: 'Type something...',
    buttons: [],
    // height: '100px',
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Action Description': this.dynamicLabel?.['ACTION_DESCRIPTION'],
    };

    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.parallelWorkflowActionObj[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.parallelWorkflowActionObj[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  changeExpcetedClosureOnDate(items: any) {
    this.targetDateToFieldValue = document.getElementById('targetDate-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.targetDateToFieldValue.style.color = '';
    } else {
      this.targetDateToFieldValue.style.color = 'red';
    }
  }

  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.isProcessing = true;
        this.coreBusinessAreaNameDropdown = [];

        if (item.displayExp == undefined) {
          this.bussinessAreaName = item;
          let businessAreaValue = this.filteredRequestedAtValue.find((x: any) => x.taskRequestedAt === item);
          this.filteredBusinessAreaValue = businessAreaValue.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        } else {
          this.bussinessAreaName = item.displayExp;
          let businessAreaValue = this.filteredRequestedAtValue.find((x: any) => x.taskRequestedAt === item.displayExp);
          this.filteredBusinessAreaValue = businessAreaValue.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }

        if (this.activityAtFieldValue != undefined) {
          this.activityAtFieldValue.style.color = '';
        }
        this.isProcessing = false;
      } else if (this.searchingByRequestedAt == null) {
        this.coreBusinessAreaNameValue = [];
        this.coreBusinessAreaNameDropdown = [];
        this.bussinessAreaName = '';
      }
    }
  }
  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    if (this.filteredBusinessAreaValue?.length != 0) {
      for (let i = 0; i < this.filteredBusinessAreaValue?.length; i++) {
        this.coreBusinessAreaNameDropdown = this.coreBusinessAreaNameDropdown.concat({
          valueExp: this.filteredBusinessAreaValue[i],
          displayExp: this.filteredBusinessAreaValue[i]
        });
      }
    }
  }
  @ViewChild('coreBusinessAreaName') coreBusinessAreaName: MatSelect;
  coreBusinessAreaNameSelected = false;
  toggleAllSelection(value: any) {
    if (value == 'coreBusinessAreaName') {
      if (this.coreBusinessAreaNameSelected) {
        this.coreBusinessAreaName.options.forEach((item: MatOption) => item.select());
      } else {
        this.coreBusinessAreaName.options.forEach((item: MatOption) => item.deselect());
      }
    }
  };

  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectCoreBusinessAreaNameValueExp = item.valueExp;
        if (this.coreBusinessAreaNameValueFieldValue != undefined) {
          this.coreBusinessAreaNameValueFieldValue.style.color = '';
        }
        setTimeout(() => {
          this.coreBusinessAreaNameSelected = this.coreBusinessAreaNameDropdown.length == this.coreBusinessAreaNameValue.length
        })
      } else {
        this.coreBusinessAreaNameSelected = false;
        if (this.coreBusinessAreaNameValueFieldValue != undefined) {
          this.coreBusinessAreaNameValueFieldValue.style.color = 'red';
        }
      }
    }
  }

  onAssignedToSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.assignedToFieldValue != undefined) {
          this.assignedToFieldValue.style.color = '';
        }
      }
    }
  }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDepartmentValue = item.valueExp;
      }
    }
  }

  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDesignationValue = item.valueExp;
      }
    }
  }

  onFieldFocusout() {
    if (this.actionNameFieldValue != undefined) {
      if (this.parallelWorkflowActionObj.actionName == "" || this.parallelWorkflowActionObj.actionName == undefined) {
        this.actionNameFieldValue.style.color = 'red';
      } else {
        this.actionNameFieldValue.style.color = '';
      }
    }

    if (this.performedActionDetailsFieldValue != undefined) {
      if (this.parallelWorkflowActionObj.performedActionDetails == null || this.parallelWorkflowActionObj.performedActionDetails == undefined || this.parallelWorkflowActionObj.performedActionDetails == '') {
        this.performedActionDetailsFieldValue.style.color = 'red';
      } else {
        this.performedActionDetailsFieldValue.style.color = '';
      }
    }

    if (this.deleteReasonFieldValue != undefined) {
      if (this.parallelWorkflowActionObj.deleteReason == "" || this.parallelWorkflowActionObj.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '';
      }
    }
  }
  datePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: new Date(),
    maxDate: new Date(this.qmsservice.activity.expcetedClosureOn),
  }

  mandatoryValidation(elementIds: any) {
    elementIds.forEach((elementId: any) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    })
  }

  actionTypeTxt: any;
  addAndEditFunction() {

    const validations: any = [];

    validations.push(
      { condition: !this.parallelWorkflowActionObj.actionName, id: 'actionName-validation' },
      { condition: !this.parallelWorkflowActionObj.targetDate, id: 'targetDate-validation' },
      { condition: this.qmsservice.moduleName != 'CC' && !this.searchingByRequestedAt, id: 'activityAt-validation' },
      { condition: this.qmsservice.moduleName != 'CC' && !this.coreBusinessAreaNameValue.length, id: 'coreBusinessAreaNameValue-validation' },
      { condition: !this.parallelWorkflowActionObj.assignedTo, id: 'assignedTo-validation' },
      {
        condition: this.qmsservice.moduleName === 'CAPA' && this.dynamicLabel['ACTION_TYPE'].isRemovable != 'Y' &&
          (!this.parallelWorkflowActionObj.actionType ||
            this.parallelWorkflowActionObj.actionType.length === 0),
        id: 'actionType-validation'
      }

    )

    const invalidIds = validations.filter((validation: any) => validation.condition).map((validation: any) => validation.id);

    if (invalidIds.length > 0) {
      this.mandatoryValidation(invalidIds);
      this.showSnackBar('Please enter all mandatory fields', 'E');
    } else {
      this.isProcessing = true;
      this.parallelWorkflowActionObj.listOfStages = "";
      this.parallelWorkflowActionObj.listOfFlexifields = "";

      this.parallelWorkflowActionObj.refNo = this.qmsservice.activityId;
      this.parallelWorkflowActionObj.module = this.qmsservice.moduleName;

      if (this.parallelWorkflowActionObj.targetDate) {
        const targetDateValue = new Date(this.parallelWorkflowActionObj.targetDate);
        this.parallelWorkflowActionObj.targetDate = this.appService.dateZoneConvertion(targetDateValue);
      } else {
        this.parallelWorkflowActionObj.targetDate = null;
      }

      if (this.qmsservice.moduleName == 'CC') {
        this.parallelWorkflowActionObj.actionAt = null;
      } else if (this.searchingByRequestedAt) {
        this.parallelWorkflowActionObj.actionAt = this.searchingByRequestedAt;
      } else {
        this.parallelWorkflowActionObj.actionAt = null;
      }
      if (this.qmsservice.moduleName === 'CAPA') {
        this.parallelWorkflowActionObj.actionType =
          this.parallelWorkflowActionObj.actionType?.join(',') || null;
      } else {
        this.parallelWorkflowActionObj.actionType = null;
      }

      this.parallelWorkflowActionObj.coreBusinessArea = "";
      this.parallelWorkflowActionObj.refNo = this.qmsservice.activityId;

      if (this.qmsservice.moduleName == 'CC') {
        this.parallelWorkflowActionObj.coreBusinessArea = null;
      } else if (this.coreBusinessAreaNameDropdown.length > 0) {
        if (this.coreBusinessAreaNameValue.length > 0) {
          for (let y = 0; y < this.coreBusinessAreaNameValue.length; y++) {
            this.parallelWorkflowActionObj.coreBusinessArea += this.coreBusinessAreaNameValue[y];
            this.parallelWorkflowActionObj.coreBusinessArea += y == this.coreBusinessAreaNameValue.length - 1 ? "" : ",";
          }
        } else {
          this.parallelWorkflowActionObj.coreBusinessArea = null;
        };
      } else {
        this.parallelWorkflowActionObj.coreBusinessArea = this.coreBusinessAreaNameValue;
      }

      if (this.searchByDepartmentCode) {
        this.parallelWorkflowActionObj.assignedToDepartment = this.searchByDepartmentCode;
      } else {
        this.parallelWorkflowActionObj.assignedToDepartment = null;
      }

      let data = this.parallelWorkflowActionObj;
      data.actionPerformed = "N";
      data.actionDescription = this.parallelWorkflowActionObj.actionDescription;
      data.workflowId = this.qmsservice.workflowId;
      data.comments = this.parallelWorkflowActionObj.comments;
      data.justification = this.parallelWorkflowActionObj.justification;

      if (this.visibleEditButton) {
        delete this.parallelWorkflowActionObj.updatedOn;
        delete this.parallelWorkflowActionObj.createdOn;
        data.actionId = this.parallelWorkflowActionObj.actionId;
        data.slNo = this.parallelWorkflowActionObj.slNo;
        this.appService.updateParallelWorkflowActions(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        this.appService.createParallelWorkflowActions(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getcallMethod();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }

    }
  };
  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  };
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  };
  onworkflowChildValueEmitted() {
    this.addworkflow = false;
  }



  deleteReasonFieldValue: any;
  deleteFiledValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  workflowId: number = 0;
  actionId: any;
  refNo: any;
  deleteReason: any = null;
  deleteCodelist(deletingData: any) {
    this.popupTitle = "Delete Action";
    this.workflowId = deletingData.WORKFLOW_ID;
    this.actionId = deletingData.ACTION_ID;
    this.refNo = deletingData.REF_NO;
    this.deleteReason = null;
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  deleteFunction(deletingData: any) {
    if (this.deleteReason) {
      this.isProcessing = true;

      const deleting_obj = {
        workflowId: this.workflowId,
        actionId: this.actionId,
        refNo: this.refNo,
        deleteReason: this.deleteReason,
      }

      this.appService.deleteParallelWorkflowActions(deleting_obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getcallMethod();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDelete() {
    this.visibleDeletePopup.close();
  }

  idMapping: Record<string, string> = { 'CR': this.qmsservice.activity.crId, 'CAPA': this.qmsservice.activity.capaId, 'DV': this.qmsservice.activity.dvId, 'IN': this.qmsservice.activity.inId, 'QI': this.qmsservice.activity.qiId, 'CC': this.qmsservice.activity.ccId };
  auditTrail: any = {};
  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, action: any) {
    let actionName;

    if (action) {
      if (action.ACTION_NAME.length > 20) {
        actionName = action.ACTION_NAME.slice(0, 20) + '...';
      } else {
        actionName = action.ACTION_NAME;
      }
    } else {
      actionName = 'OverAll';
    }
    this.auditTrail.refNo = viewType == 'overAll' ? null : action.ACTION_ID;
    this.auditTrail.viewType = viewType;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'PARALLEL_WORKFLOW_ACTIONS';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' Parallel Workflow Actions Audit Trail [' + this.idMapping[this.qmsservice.moduleName] + (viewType === 'overAll' ? '' : ' - ' + actionName) + ']';
    this.dynamicAuditTrailComponent.triggerTrail(action);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + '  Parallel Workflow Actions Report [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('viwerClobPopup', { static: true }) viwerClobPopup: TemplateRef<any>;
  visibleviwerClobPopup: MatDialogRef<TemplateRef<any>>;
  aviwerlPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }

    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      }, error: (error) => {
        throw error;
      }
    })
    this.isProcessing = false;

  }
  htmlContent: any;
  closeHtmlContent() {
    this.visibleviwerClobPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmit() {
    this.getcallMethod();
  };

  label: any = [];
  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      gridName: this.reportObj.gridName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  @ViewChild(SearchUsersComponent) searchUsersComponent!: SearchUsersComponent;
  searchAssignTo(workingFor: string) {
    this.searchUsersComponent.popupTitle = 'Assign To';
    this.searchUsersComponent.isSwitchingUser = workingFor == 'switch';
    this.searchUsersComponent.isSwitchingUser && (this.message.switchUserCurrentValue = this.parallelWorkflowActionObj.assignedToUser);
    this.searchUsersComponent.selectionMode = 'single';
    this.searchUsersComponent.trigger();
  }

  onSearchUserEmitted() {
    this.parallelWorkflowActionObj.assignedToUser = this.qmsservice.selectedSearchUserId;
    this.parallelWorkflowActionObj.assignedTo = this.qmsservice.selectedSearchUserName;
    if (this.searchUsersComponent.isSwitchingUser) {
      this.addAndEditFunction();
    }
  }

  @ViewChild('actionTypeSelect') actionTypeSelect?: MatSelect;

  isActionTypeAllSelected(): boolean {
    if (!this.dropDownActionType || !this.parallelWorkflowActionObj?.actionType) return false;
    const selected = this.parallelWorkflowActionObj.actionType || [];
    return selected.length > 0 && selected.length === this.dropDownActionType.length;
  }

  toggleActionTypeAllSelection(isChecked: boolean): void {
    if (!this.dropDownActionType) return;
    this.parallelWorkflowActionObj.actionType = isChecked
      ? this.dropDownActionType.map(opt => opt.valueExp)
      : [];

    if (this.actionTypeSelect) {
      this.actionTypeSelect.writeValue(this.parallelWorkflowActionObj.actionType);
    }
  }

  public focusEmpty(): void {
    console.log();
  }
}
